import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Tenants stats DTO
 */
@CaslSubject(AppSubjectEnum.TENANT)
export class TenantsStatsDto extends BaseStatsDto {
	active!: number;
	onNoticePayment!: number;
	onHold!: number;
	inactive!: number;
	awaitingTermination!: number;
}
